import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import AppFooter from "../components/AppFooter";

export default function ContactPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-cyan-50 to-blue-100 relative overflow-hidden">

      {/* Background Glow */}
      <div className="absolute top-0 left-0 w-[400px] h-[400px] bg-white/30 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-[350px] h-[350px] bg-cyan-300/30 rounded-full blur-3xl"></div>

      {/* Grid */}
      <div className="absolute inset-0 opacity-[0.04] bg-[linear-gradient(to_right,#0f172a_1px,transparent_1px),linear-gradient(to_bottom,#0f172a_1px,transparent_1px)] bg-[size:40px_40px]"></div>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 py-16">

        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-800">
            Contact Us
          </h1>

          <p className="mt-4 text-slate-600 max-w-2xl mx-auto text-sm sm:text-base">
            We’re here to help you with any queries regarding AICA HEALTH services, support, or partnership.
          </p>
        </div>

        {/* Contact Card */}
        <div className="relative overflow-hidden rounded-3xl border border-white/40 bg-white/60 backdrop-blur-2xl shadow-xl p-8 text-center">

          <h2 className="text-xl sm:text-2xl font-semibold text-slate-800 mb-6">
            Get in Touch
          </h2>

          <p className="text-slate-600 text-sm sm:text-base leading-relaxed">
            For any queries, please write to us at{" "}
            <a
              href="mailto:a@aicahealth.com"
              className="text-cyan-600 font-semibold hover:underline"
            >
              a@aicahealth.com
            </a>
            {" "}or call our AICA Helpline{" "}
            <a
              href="tel:+919821286111"
              className="text-cyan-600 font-semibold hover:underline"
            >
              +91 98212 86111
            </a>
          </p>

        </div>

        {/* Footer */}
        <div className="mt-10 flex justify-center">

          <button
            onClick={() => navigate("/")}
            className="
            flex items-center gap-2
            px-6 py-3
            rounded-2xl
            bg-gradient-to-r from-cyan-500 to-blue-500
            text-white
            font-semibold
            shadow-lg
            hover:scale-105
            hover:shadow-cyan-300/50
            transition-all duration-300
          "
          >
            <ArrowLeft size={18} />
            Go Back
          </button>

        </div>

      

      {/* FOOTER */}
      {/* <AppFooter /> */}
       

      </div>
    </div>
  );
}